var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "mathlive-editor",
        draggable: true,
        height: "120px",
        width: "420px",
        "click-to-close": true,
      },
      on: { opened: _vm.onOpened, closed: _vm.onCancel },
    },
    [
      _c("div", { attrs: { id: "mathlive-editor" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-mathlive" },
        [
          _c(
            "v-btn",
            {
              attrs: { "x-small": "", outlined: "", color: "indigo" },
              on: { click: _vm.onOk },
            },
            [_vm._v("OK")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }